import {
    ADEMPIMENTI_FISCALI_CONFIG_START,
    ADEMPIMENTI_FISCALI_CONFIG_ERROR,
    ADEMPIMENTI_FISCALI_CONFIG_SUCCESS,
    ADEMPIMENTI_FISCALI_CONFIG_RESET
} from "../../actions/services/a-fiscali-iva";

const defaultState = {
    status: {
        started: false,
        error: false,
        ended: false,
        errorInfo: {
            code: "",
            message: ""
        }
    }
};

export default function aFiscaliIva(state = defaultState, { type, payload, error }) {
    switch (type) {
        case ADEMPIMENTI_FISCALI_CONFIG_START:
            return {
                status: {
                    started: true,
                    error: false,
                    ended: false
                }
            };
        case ADEMPIMENTI_FISCALI_CONFIG_SUCCESS:
            return {
                status: {
                    started: false,
                    error: false,
                    ended: true
                },
                ...payload
            };
        case ADEMPIMENTI_FISCALI_CONFIG_ERROR:
            return {
                status: {
                    started: false,
                    error: true,
                    ended: false,
                    errorInfo: { code: error.code, message: error.message }
                }
            };
        case ADEMPIMENTI_FISCALI_CONFIG_RESET:
            return defaultState;

        default:
            return state;
    }
}
